<template>
  <header>

    <div v-if='screenSize.mobile === false'
         class="base-five large-text high-light border-bottom">

      <span id="quote-marks"
            class="quote-marks">
        <img src='../assets/quotes333.svg'>
      </span>

      <dsMarquee v-if='loaded.quotes && screenSize.mobile === false'
                 :language='language'
                 :quotes='quotes'>
      </dsMarquee>

    </div>

    <div v-if='screenSize.mobile === false'
         class='base-five border-bottom main-column'>
      <dsMenu :language='language'>
      </dsMenu>

    </div>

    <div v-if='screenSize.mobile === false'
         class='base-five border-bottom secondary-column'>
      <div class='search-field'>
        <input v-if='language ==="nl"'
               placeholder='Zoek...'
               class='large-text secondary-color center-vertical'
               v-model='searchTerm'
               @keyup.enter='search' />
        <input v-if='language ==="en"'
               placeholder='Search...'
               class='large-text secondary-color center-vertical'
               v-model='searchTerm'
               @keyup.enter='search' />
        <div @click='search'></div>
      </div>
      <div class='language-switch'>
        <router-link :to="{name: routeName, params: {language: 'en', slug: routeSlug}}"
                     :class='{active: (language === "en")}'
                     class='language-switch-button'>EN</router-link>
        <router-link :to="{name: routeName, params: {language: 'nl', slug: routeSlug}}"
                     :class='{active: (language === "nl")}'
                     class='language-switch-button'>NL</router-link>
      </div>
    </div>

  </header>
</template>

<script>
import dsMarquee from './dsMarquee'
import dsMenu from './dsMenu'
export default {
  name: 'dsHeader',
  components: {
    dsMarquee,
    dsMenu
  },
  data() {
    return {
      searchTerm: ''
    }
  },
  props: ['language', 'screenSize', 'quotes', 'loaded'],
  computed: {
    routeName() {
      if (this.$route.name) {
        return this.$route.name
      } else {
        return 'home'
      }
    },
    routeSlug() {
      if (this.$route.params.slug) {
        return this.$route.params.slug
      } else {
        return 'home'
      }
    }
  },
  methods: {
    search() {
      if (this.searchTerm) {
        this.$parent.$router.push({
          name: 'zoek',
          params: {
            lang: this.language,
            slug: this.searchTerm
          }
        })
        this.searchTerm = ''
      }
    }
  }
}
</script>

<style lang='scss' scoped>
@import '../styles/helpers/_mixins.scss';
@import '../styles/responsive/_manager.scss';
@import '../styles/_variables.scss';
@import '../styles/_space.scss';
@import '../styles/_color.scss';
header {
  width: 100%;
}
.language-switch {
  float: right;
}
.language-switch-button {
  @include center-vertical;
  right: 0;
  width: 50px;
  height: 3 * $baseline;
  text-align: center;
  line-height: 3 * $baseline;
  color: $secondary-color;
  border: 1px solid $secondary-color;
  &.active,
  &:hover {
    background: $secondary-color;
    color: $background-color;
  }
  &:last-child {
    right: 60px;
  }
}
.search-field {
  display: inline-block;
  height: 100%;
  width: 196px;
  position: relative;
  input {
    outline: none;
    border: 0;
    height: 100%;
    background: transparent;
    width: $sidebar;
    font-family: 'UniversLTCYR-45Light', 'helvetica', sans-serif;
    font-size: $small-text !important;
    &:focus {
      &::placeholder {
        color: transparent;
      }
      ~ div {
        opacity: 1;
      }
    }
    &:invalid {
      ~ input[type='submit'] {
        opacity: 1;
      }
    }
    &::placeholder {
      color: $secondary-color;
      font-size: $large-text;
      position: relative;
      top: 1px;
    }
  }
  div {
    top: 25px;
    display: block;
    opacity: 0;
    position: absolute;
    right: 0;
    height: $margin / 2;
    width: $margin / 2;
    transform-origin: center center;
    transform: rotate(135deg) translateY(90%);
    background: transparent;
    border: 0;
    cursor: pointer;
    border-left: 3px solid $secondary-color;
    border-top: 3px solid $secondary-color;
    z-index: 10000;
    &:hover {
      border-color: $main-color;
    }
  }
}
.quote-marks {
  pointer-events: none;
  display: block;
  width: 1.5 * $margin;
  height: (5 * $baseline) - 2px;
  background: $background-color;
  z-index: 1000;
  @include center-vertical;
  img {
    @include center-vertical;
    left: -3px;
    top: 52%;
    path {
      fill: $high-light;
    }
  }
}
</style>



// WEBPACK FOOTER //
// dsHeader.vue?3b408696